import React, { ReactNode, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useFlightSearchStore } from '../store/flightSearch/flightSearchStore';
import { useRoadSearchStore } from '../store/roadSearch/roadSearchStore';
import AuthenticatedRoute from './AuthenticatedRoute';
import { useWaterSearchStore } from '../store/waterSearch/waterSearchStore';
import { useRailSearchStore } from '../store/railSearch/railSearchStore';

type Props = {
  children: ReactNode
}
function DataFilled({ children }: Props) {
  const { tripType } = useParams();

  const navigate = useNavigate();
  const {
    formData: { OriginLocationCode, multiCity },
  } = useFlightSearchStore();

  const {
    formData: { DepartureId },
  } = useRoadSearchStore();

  const {
    formData: { DepartureId: WaterDepartureId },
  } = useWaterSearchStore();

  const {
    formData: { DepartureId: TrainDepartureId },
  } = useRailSearchStore();
  const firstOriginLocationCodeInMultiCity = multiCity && multiCity?.length > 0 && multiCity[0]?.OriginLocationCode;

  useEffect(() => {
    if ((!OriginLocationCode && !firstOriginLocationCodeInMultiCity) && tripType === 'flight') {
      navigate('/search/flight');
    }
    if (!DepartureId && tripType === 'road') {
      navigate('/search/road');
    }
    if (!WaterDepartureId && tripType === 'water') {
      navigate('/search/water');
    }
    if (!TrainDepartureId && tripType === 'rail') {
      navigate('/search/rail');
    }
  }, [DepartureId, OriginLocationCode, firstOriginLocationCodeInMultiCity, TrainDepartureId, WaterDepartureId, navigate, tripType]);
  return (
    <AuthenticatedRoute>
      {children}
    </AuthenticatedRoute>
  );
}

export default DataFilled;
